var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetPaidWithEase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23629_14254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 11.6667V19.8334C25.6668 20.7617 25.2981 21.6519 24.6417 22.3083C23.9853 22.9647 23.0951 23.3334 22.1668 23.3334H5.8335C4.90524 23.3334 4.015 22.9647 3.35862 22.3083C2.70225 21.6519 2.3335 20.7617 2.3335 19.8334V11.6667H25.6668ZM21.0002 16.3334H17.5002C17.1907 16.3334 16.894 16.4563 16.6752 16.6751C16.4564 16.8939 16.3335 17.1907 16.3335 17.5001C16.3335 17.8095 16.4564 18.1062 16.6752 18.325C16.894 18.5438 17.1907 18.6667 17.5002 18.6667H21.0002C21.3096 18.6667 21.6063 18.5438 21.8251 18.325C22.0439 18.1062 22.1668 17.8095 22.1668 17.5001C22.1668 17.1907 22.0439 16.8939 21.8251 16.6751C21.6063 16.4563 21.3096 16.3334 21.0002 16.3334ZM22.1668 4.66675C23.0951 4.66675 23.9853 5.0355 24.6417 5.69187C25.2981 6.34825 25.6668 7.23849 25.6668 8.16675V9.33341H2.3335V8.16675C2.3335 7.23849 2.70225 6.34825 3.35862 5.69187C4.015 5.0355 4.90524 4.66675 5.8335 4.66675H22.1668Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23629_14254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaidWithEase);
export default __webpack_public_path__ + "static/media/get-paid-with-ease.ab797684d0f86fe397fb2eb516e85c4d.svg";
export { ForwardRef as ReactComponent };